
angular.module('mtic.components.navbar')
.directive('navBarVolume', function (volumeCaptionStatus, EventManager, language, PlatformService) {
  return {
    templateUrl: 'template.html',
    restrict: 'E',
    scope: {},
    link: function (scope, element, attrs) {
      var eventManager = new EventManager('navBarVolume', scope)

      scope.isMobile = PlatformService.isMobile;

      scope.status = {
        volumeOn: true,
        captionsOn: false,
        changeStatus: function(type){
          this[type + 'On'] = !this[type + 'On'];
          volumeCaptionStatus.set(this.volumeOn, this.captionsOn);
          eventManager.broadcast('navigation:' + type + ':change', this[type + 'On']);
        }

      }
      scope.language = language;
      scope.classes = {
        main: function(){
          return scope.status.volumeOn ? {} : {'nav-item__sound--off' : true}
        },
        sounds: function(){
          return scope.status.volumeOn ? {'nav-item__soundToggle--on' : true} : {}
        },
        captions: function(){
          return scope.status.captionsOn ? {'nav-item__soundToggle--on' : true} : {}
        }
      }
    }
  }
})
